import React, { useState, Fragment, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { ClientOnly } from '../SSRSwitch'
import AvatarIcon from '../icons/Avatar'
import styles from './styles'
import getLoginPortalUrl from '../../utils/getLoginPortalUrl'
import Avatar from '../Avatar'

const Login = (props) => {
  const [state, setState] = useState({
    menuIsActive: false,
  })

  useEffect(() => {
    setState({ menuIsActive: props.accountMenuActive })
  }, [props.accountMenuActive])

  useEffect(() => {
    if (window && window.innerWidth < 768) {
      if (state.menuIsActive) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = null
      }
    }
  }, [state.menuIsActive])

  const userData = useSelector(userState => userState.user)
  const loginData = useSelector(loginState => loginState.loginStatus)
  const playerHeadReducer = useSelector(playerState => playerState.playerHeader)

  useEffect(() => {
    if (playerHeadReducer.activeState) {
      closeMenu()
    }
  }, [playerHeadReducer])

  const onBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      if (window && window.innerWidth > 767) {
        closeMenu()
      }
    }
  }

  const closeMenu = () => {
    setState({ menuIsActive: false })
    props.setAccountMenuActive(false)
  }

  const profileHost = getLoginPortalUrl(props.currentDomain)

  if (!loginData.loginEnabled) return null

  return (
    <ClientOnly>
      <div className="Login" onBlur={onBlur}>
        {
          userData.isLoggedIn && (
            <Fragment>
              <div className={`avatar-outer ${state.menuIsActive ? 'active' : 'inactive'}`}>
                <div className="avatar-container">
                  {/* eslint-disable-next-line max-len */}
                  <Avatar userInitial={userData.firstName.charAt(0)} link={'/account'} currentlySubscribed={userData.currentlySubscribed} isHeaderMenu />
                </div>
              </div>
            </Fragment>
          )
        }
        {
          userData.isLoggedIn === false && userData.gettingDetails && (
            <Fragment>
              <a
                // eslint-disable-next-line max-len
                className="log-in-link signed-out"
                href={`${profileHost}?siteAction=remoteLogin&source=${encodeURIComponent(props.currentUrl)}`}
              >
                <div className="avatar signedOut"><AvatarIcon /></div>
                <p className="login-text">Sign in/Join</p>
              </a>
            </Fragment>
          )
        }
        <style jsx>{styles}</style>
      </div>
    </ClientOnly>
  )
}

Login.propTypes = {
  currentDomain: PropTypes.string.isRequired,
  currentUrl: PropTypes.string.isRequired,
  setAccountMenuActive: PropTypes.func,
  loginService: PropTypes.shape({
    logOut: PropTypes.func,
  }).isRequired,
  accountMenuActive: PropTypes.bool,
}

Login.defaultProps = {
  setAccountMenuActive: () => { },
  accountMenuActive: false,
}

export default Login
